import { useState } from 'react';
import { Drawer } from '@mui/material';
import { WizardProvider } from 'redesign';
import { BulkShiftActionData } from 'api';
import { BulkActionProvider } from 'shared/providers/bulk-action-provider';
import { BulkShiftActionResult } from './bulk-shift-action-result/bulk-shift-action-result';
import { BulkShiftArchiveFormProvider } from './bulk-shift-archive-form/bulk-shift-archive-form-provider';

type BulkArchiveSidebarProps = {
  selectedShiftIds: string[];
  isBulkArchiveBarOpen: boolean;
  setIsBarSideBarOpen: (isOpen: boolean) => void;
};

export const BulkArchiveSidebar = ({
  selectedShiftIds,
  isBulkArchiveBarOpen,
  setIsBarSideBarOpen,
}: BulkArchiveSidebarProps) => {
  const [mutationResult, setMutationResult] = useState<BulkShiftActionData>({
    fulfilled: [],
    failure: [],
  });

  return (
    <BulkActionProvider
      setMutationResult={setMutationResult}
      selectedIds={selectedShiftIds}
      failure={mutationResult.failure}
      fulfilled={mutationResult.fulfilled}
    >
      <Drawer
        anchor="right"
        open={isBulkArchiveBarOpen}
        onClose={() => setIsBarSideBarOpen(false)}
        PaperProps={{ style: { width: 600 } }}
      >
        <WizardProvider onClose={() => setIsBarSideBarOpen(false)}>
          <BulkShiftArchiveFormProvider />
          <BulkShiftActionResult />
        </WizardProvider>
      </Drawer>
    </BulkActionProvider>
  );
};
